import delay from './delay.js'
import { updateQueryParam } from './query.js'

/**
 * @param {string} inputId
 * @param {string|null} listId
 */
export function filterable(inputId, listId) {
    const input = document.getElementById(inputId)
    if (!input) return
    input.addEventListener("input", delay(filter(inputId, listId), 300), false)
    const params = new URLSearchParams(window.location.search);
    const search = params.get('search')
    /** @type {HTMLInputElement} */
    const inputEl = /** @type {HTMLInputElement} */ (input);
    inputEl.value = search || ''
    triggerFilter(inputId)
}

/**
 * @param {string} inputId
 */
export function triggerFilter(inputId) {
    const input = document.getElementById(inputId)
    if (!input) return
    
    const inputEl = /** @type {HTMLInputElement} */ (input);
    if (inputEl.value.trim())
        inputEl.dispatchEvent(new Event('input', {bubbles: true}))
}

function filter(inputId, listId) {
    return function () {
        /** @type {HTMLInputElement} */
        const inputEl = /** @type {HTMLInputElement} */ (this);
        const inputValue = inputEl.value;
        let filter = inputValue.toLowerCase().trim();
        filter = filter.replace(/https:.*immobilienscout24.de\/expose\//, '');
        filter = filter.replace(/#?\/$/, '');

        const ul = document.getElementById(listId ?? (inputId + '-list'))
        const lis = ul?.children || []

        // Split filter into words, ignore empty
        const words = filter.split(/\s+/).filter(Boolean)

        for(let li of lis) {
            /** @type {HTMLElement} */
            const liEl = /** @type {HTMLElement} */ (li);
            const filtertext = liEl.dataset.filtertext?.toLowerCase() || ''
            // Check if all words are present in filtertext
            const matches = words.every(word => filtertext.includes(word))
            liEl.style.display = matches ? "" : "none";
        }
        updateQueryParam('search', filter)
    }
}